// SaveTipoRiesgo.tsx
import { TipoRiesgo, TipoRiesgoForm } from "../../types";
import { useForm } from "react-hook-form";
import { ROUTER_PATHS } from "@/shared";
import { useNavigate } from "react-router-dom";
import { CustomTextField, SingleFormBoxScene } from "@/shared/components/ui";
import { useEffect, useState } from "react";
import { useFetchPostTipoRiesgo, useFetchPutTipoRiesgo } from "@/shared/actions";
import { tipoRiesgoSchema } from "../../utils";
import { yupResolver } from "@hookform/resolvers/yup";

type SaveTipoRiesgoProps = {
  titulo: string;
  data?: TipoRiesgo | null;
};

export default function SaveTipoRiesgo({ titulo, data }: SaveTipoRiesgoProps) {
  const returnUrl = ROUTER_PATHS.control_cambios.tipoRiesgoNav;
  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);

  const createTipoRiesgo = useFetchPostTipoRiesgo({ navigate, returnUrl });
  const updateTipoRiesgo = useFetchPutTipoRiesgo(navigate, returnUrl);

  const form = useForm<TipoRiesgoForm>({
    resolver: yupResolver(tipoRiesgoSchema) as any,
    mode: "onChange",
    defaultValues: {
      nombre: "",
      estado: true,
    },
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;

  const onSave = () => {
    if (!isValid) return;
    const values = { ...form.getValues() };
    if (data?.tipoRiesgoId) {
      return updateTipoRiesgo.mutate({
        id: data.tipoRiesgoId,
        data: values as any,
      });
    }
    return createTipoRiesgo.mutate(values);
  };

  useEffect(() => {
    if (data) {
      setShrink(true);
      reset({
        nombre: data.nombre ?? "",
        estado: data.estado ?? true,
      });
    }
  }, [data]);

  return (
    <SingleFormBoxScene
      titlePage={titulo}
      onCancel={() => navigate(returnUrl)}
      onSave={handleSubmit(onSave)}
    >
      <CustomTextField
        label="Nombre del tipo de riesgo"
        name="nombre"
        control={form.control}
        defaultValue={form.getValues().nombre || ""}
        error={errors.nombre}
        helperText={errors.nombre?.message ?? ""}
        shrink={shrink}
      />
    </SingleFormBoxScene>
  );
}
